import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsTitle } from 'common/clubs/services';
import { RsTitleInfo } from 'common/customers/services/types/RsTitleInfo';
import { TitleAdd } from 'common/customers/services/types/TitleAdd';
import { TitleUpdate } from 'common/customers/services/types/TitleUpdate';

export function customerTitleFromGetToUpdateParams(params: RsTitleInfo): TitleAdd {
    return {
        name: params.name,
        nameLatin: params.nameLatin,
        orderNo: params.orderNo,
        sex: params.sex
    };
}

export type ICustomerTitleDataProvider = IDataProviderV2<RsTitle, RsTitleInfo, TitleAdd, TitleUpdate>;

export class CustomerTitleDataProvider
    extends AbstractDataProviderV2<RsTitle, RsTitleInfo, TitleAdd, TitleUpdate>
    implements ICustomerTitleDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/titles');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
